<template>
  <div
    class="d-block auth-v1 px-2"
    style="overflow: visible;align-items: baseline;justify-content: center;display: flex;"
  >
    <div class="auth-inner py-2">
      <b-card class="mb-0 text-center">
        <b-link class="brand-logo">
          <icon-logo width="20%" />
        </b-link>

        <b-card-title class="m-1">
          {{ fullName }}
        </b-card-title>
        <b-card-text class="mb-1 ml-1">
          Hola {{ userRol.nombre }}, debes verificar que eres tú para poder continuar.
        </b-card-text>
        <b-card-body>
          <b-row>
            <b-col md="12">
              <div v-if="!showLoader">
                <validation-observer ref="formularioVerify">
                  <b-form
                    class="auth-reset-password-form my-2"
                    @submit.prevent="validationForm"
                  >
                    <!-- password -->
                    <b-form-group
                      label="Contraseña"
                      label-for="new-password"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="contraseña"
                        vid="Password"
                        rules="required"
                      >
                        <b-input-group
                          class="input-group-merge"
                          :class="errors.length > 0 ? 'is-invalid':null"
                        >
                          <b-form-input
                            id="password-field"
                            v-model="password"
                            autocomplete="off"
                            :type="password1FieldType"
                            :state="errors.length > 0 ? false:null"
                            class="form-control-merge"
                            name="new-password"
                            placeholder="············"
                          />
                          <b-input-group-append is-text>
                            <feather-icon
                              class="cursor-pointer"
                              :icon="password1ToggleIcon"
                              @click="togglePassword1Visibility"
                            />
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>

                    <!-- submit button -->
                    <b-button
                      block
                      type="submit"
                      variant="primary"
                    >
                      <feather-icon
                        icon="KeyIcon"
                        class="mr-50"
                      />
                      <span class="align-middle">Proceder..</span>
                    </b-button>
                  </b-form>
                </validation-observer>
              </div>
              <div v-else>

                <div class="pt-3">
                  <b-progress
                    animated
                    value="100"
                    class="progress-bar-primary"
                    variant="primary"
                  />

                  <div class="text-center mt-1 mb-2">
                    <span>Verificando ...</span>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard,
  BRow,
  BCol,
  BCardText,
  BCardBody,
  BCardTitle,
  BButton,
  BForm,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BProgress,
  BFormInput,
} from 'bootstrap-vue'
import { ref, computed } from '@vue/composition-api'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { formhttp } from '@core/utils/utils'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import IconLogo from '@core/layouts/components/IconoLogo.vue'
import { rolesActions } from '@core/mixins/account-data/roles'
import { checkPassAccount } from './useSignin'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BCardText,
    BCardBody,
    BCardTitle,
    BForm,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BLink,
    BProgress,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    IconLogo,
  },
  directives: {
    Ripple,
  },
  mixins: [rolesActions],
  props: {
    accgranted: {
      type: Boolean,
      default: () => false,
    },
    resp: {
      type: [Object, null],
      default: null,
    },
  },
  setup(props, { emit }) {
    const toast = useToast()
    const cPassword = ref('')
    const password = ref('')
    const password1FieldType = ref('password')
    // const password2FieldType = ref('password')
    const formularioVerify = ref(null)
    const showLoader = ref(false)
    // const { cleanUserData } = logout()

    //* Change type input to see password (pass)
    const togglePassword1Visibility = () => {
      password1FieldType.value = password1FieldType.value === 'password' ? 'text' : 'password'
    }

    //* Change type input to see password (confirm pass)
    // const togglePassword2Visibility = () => {
    //   password2FieldType.value = password2FieldType.value === 'password' ? 'text' : 'password'
    // }

    //* Change icon in inputs (Eye)
    const password1ToggleIcon = computed(() => (password1FieldType.value === 'password' ? 'EyeIcon' : 'EyeOffIcon'))
    // const password2ToggleIcon = computed(() => (password2FieldType.value === 'password' ? 'EyeIcon' : 'EyeOffIcon'))

    //* Check current pass, then redirect to change it
    const verifyPass = () => {
      showLoader.value = true
      checkPassAccount(password.value)
        .then(response => {
          const { icon, label } = formhttp(response.status)
          showLoader.value = false

          if (response.status === 200) {
            emit('update:resp', response.data)
            emit('update:accgranted', true)
            emit('closeCheckin')
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Verificación de identidad',
                text: response.message,
                icon,
                variant: label,
              },
            }, { timeout: 20000, position: 'top-center' })
          }
        }, error => {
          showLoader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Verificación de identidad',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    const fullName = computed(() => store.getters['cuenta/getFullName'])

    //* Validate form
    const validationForm = () => {
      formularioVerify.value.validate().then(success => {
        if (success) verifyPass()
      })
    }

    return {
      // Variables
      cPassword,
      password,
      password1FieldType,
      // password2FieldType,
      fullName,

      // Flags
      showLoader,

      // Methods
      togglePassword1Visibility,
      // togglePassword2Visibility,
      validationForm,

      // Computed
      password1ToggleIcon,
      // password2ToggleIcon,

      // Refs
      formularioVerify,

      // Filters
      required,
    }
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/pages/page-auth.scss';
</style>
